import styled from 'styled-components';

export const HeaderWrapper = styled.div`
    [class*='inlineTopNavigation']:not([class*='inlineControlButtons']),
    [class*='LargeMenu'] > div:not([class*='largeMenuRight']) {
        max-width: 1180px;
        margin: 0 auto;
        padding-left: 10px;
        padding-right: 10px;
    }

    [class*='largeMenuInner'] {
        padding-left: 75px !important;
    }
`;
